export default {
  pending_approval: {
    id: 1,
    name: "Pending",
    tag_type: "warning",
    colour: "#DFCD36",
    bg_colour: "#F7F9C3",
  },
  submitted: {
    id: 4,
    name: "Submitted",
    tag_type: "warning",
    colour: "#67C23A",
    bg_colour: "#DBFCC8",
  },
  sent: {
    id: 5,
    name: "Sent",
    tag_type: "danger",
    colour: "#4A00FA",
    bg_colour: "#D5EFF1",
  },
  approved: {
    id: 2,
    name: "Approved",
    tag_type: "success",
    colour: "#fff",
    bg_colour: "#67C23A",
  },
  declined: {
    id: 3,
    name: "Declined",
    tag_type: "danger",
    colour: "#FFD6D6",
    bg_colour: "#FF6E6E",
  },
};
